import React from 'react';
import {browserHistory, Link} from 'react-router';
import LoginInputLabel from '@components/input-label/LoginInputLabel';
import LoginTextField from '@components/text-field/LoginTextField';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import {EMAIL_REGEX} from 'utils/regexValidators';
import {getMuiV4Theme} from 'utils/css/themeUtils';
import {PasswordSource} from '@store/password/PasswordSource';
import 'styles/Login.styl';

const arrowBackStyle = {
  height: '34px',
  width: '34px',
};

class PasswordForgot extends React.Component {
  state = {
    emailSent: false,
    emailError: '',
    email: '',
  };

  constructor(props, context) {
    super(props, context);

    this.handleEmailBlur = this.handleEmailBlur.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.submit = this.submit.bind(this);
  }

  isValid(email = this.state.email) {
    return EMAIL_REGEX.test(email);
  }

  async submit(event) {
    if (this.isValid()) {
      try {
        PasswordSource.forgotPassword(this.state.email).catch(console.error);
      } finally {
        this.setState({emailSent: true});
      }
    }
  }

  /**
   * Submit when user presses Enter
   */
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.submit();
    }
  }

  handleEmailChange(event) {
    const email = event.target.value;
    this.setState({
      email,
      emailError: this.isValid(email) ? '' : this.state.emailError,
    });
  }

  handleEmailBlur(event) {
    const email = event.target.value;
    this.setState({
      emailError: this.isValid(email) ? '' : 'Must be a valid email.',
    });
  }

  handleSupportClick() {
    window.open('https://support.mediafly.com/hc/en-us', '_blank');
  }

  goHome() {
    browserHistory.push('/');
  }

  render() {
    const formMessage = this.state.emailSent
      ? `If there is a user account registered to this email address, we have sent an email with a link to reset the password.`
      : null;

    return (
      <div className="login-component">
        <div className="go-back">
          <Link to={'/login'}>
            <ArrowBackIcon style={arrowBackStyle} color={getMuiV4Theme().palette.primary.main} />
          </Link>
        </div>
        {(() => {
          if (formMessage) {
            return <div className="form-text message">{formMessage}</div>;
          }
        })()}
        {(() => {
          if (formMessage) {
            return (
              <Button
                className="submit-button space-below"
                type="submit"
                onClick={this.goHome}
                disabled={!this.isValid()}
                size="large"
                color="primary"
                variant="contained">
                OK
              </Button>
            );
          } else {
            return (
              <form name="password-reset-form" onSubmit={this.submit}>
                <div className="form-text">
                  Forgot your password? No problem. Enter your email address to have a reset link
                  sent to you.
                </div>
                <LoginInputLabel htmlFor="password-reset-email" className="text-field-label">
                  Email
                </LoginInputLabel>
                <LoginTextField
                  id="password-reset-email"
                  autoFocus
                  name="email"
                  className="text-field email"
                  error={!!this.state.emailError}
                  errorText={this.state.emailError}
                  underlineShow={false}
                  fullWidth={true}
                  onChange={this.handleEmailChange}
                  onBlur={this.handleEmailBlur}
                  value={this.state.email}
                />
                {(() => {
                  if (this.state.errorMessage != null) {
                    return <div className="error-message">{this.state.errorMessage}</div>;
                  }
                })()}
                <Button
                  className="submit-button"
                  type="submit"
                  onClick={this.submit}
                  disabled={!this.isValid()}
                  size="large"
                  color="primary"
                  variant="contained">
                  Send Reset Link
                </Button>
              </form>
            );
          }
        })()}
        <div className="support-button" onClick={this.handleSupportClick}>
          Get Support
        </div>
      </div>
    );
  }
}

PasswordForgot.displayName = 'PasswordForgot';

export default PasswordForgot;
